import styled from 'styled-components';
import tw from 'twin.macro'


const TableStyles = styled.div.attrs({
  className : "overflow-auto lg:overflow-visible mt-8 sm:mt-0"
})`
  & {
      table{
        ${tw`w-full border-separate`}
        border-spacing: 0 8px;
        
        th {
          ${tw`whitespace-nowrap px-4 py-3 text-left font-medium text-gray-700`}
        }

        tbody tr {
          ${tw`bg-white shadow-sm rounded-lg`}
          
          td:first-child {
            ${tw`rounded-l-lg`}
          }
          
          td:last-child {
            ${tw`rounded-r-lg`}
          }
        }

        td{
          ${tw`px-4 py-4 border-t border-b border-gray-100`}
          
          &:first-child {
            ${tw`border-l`}
          }
          
          &:last-child {
            ${tw`border-r`}
          }
          
          .name{
            ${tw`font-medium whitespace-nowrap text-gray-900`}
          }
          .id{
            ${tw`text-gray-500 text-xs whitespace-nowrap mt-1`}
          }
        }
      }
  }
`
export default TableStyles;
